import { clsx } from 'clsx';
import { ReactNode } from 'react';

import { unescapeUnicode } from 'utils/unicodeUtils';

type InformationProps = {
    children: ReactNode;
    className?: string;
};

export const Information = ({ children, className }: InformationProps) => (
    <div className={clsx('flex flex-col gap-4 p-4 text-sm', className)}>{children}</div>
);

type InformationSectionProps = {
    title: string;
    children: ReactNode;
    className?: string;
};

export const InformationSection = ({ title, children, className }: InformationSectionProps) => (
    <div className={className}>
        <div className="flex flex-col">
            <div className="gap-base flex">
                <h6 className="text-base">{unescapeUnicode(title)}</h6>
            </div>
            {children}
        </div>
    </div>
);
